import { COMPLETION_STATES, isBoundContext } from "%/dynamic-component-editor/helpers/completion-card-context-gaps";

const LEGACY_FLAT_KEY = "context-bindings";

function isPlainObject(value) {
  return Boolean(value) && typeof value === "object" && !Array.isArray(value);
}

function cloneStates(bindingsByState) {
  const out = {};
  Object.entries(isPlainObject(bindingsByState) ? bindingsByState : {}).forEach(([state, bindings]) => {
    out[state] = isPlainObject(bindings) ? { ...bindings } : {};
  });
  return out;
}

function boundStates(cardIdsByState) {
  return COMPLETION_STATES.filter(state => Number(cardIdsByState?.[state]) > 0);
}

export function readLegacyFlatContextBindings(optionsTree) {
  for (const mode of Object.values(isPlainObject(optionsTree) ? optionsTree : {})) {
    for (const breakpoint of Object.values(isPlainObject(mode) ? mode : {})) {
      for (const state of Object.values(isPlainObject(breakpoint) ? breakpoint : {})) {
        const leaf = isPlainObject(state) ? state[LEGACY_FLAT_KEY] : undefined;
        if (leaf === undefined) {
          continue;
        }
        const raw = isPlainObject(leaf) && "r" in leaf ? leaf.r : leaf;
        return isPlainObject(raw) ? { ...raw } : {};
      }
    }
  }
  return {};
}

export function hasLegacyFlatContextBindings(optionsTree) {
  return Object.values(isPlainObject(optionsTree) ? optionsTree : {}).some(mode => Object.values(isPlainObject(mode) ? mode : {})
      .some(breakpoint => Object.values(isPlainObject(breakpoint) ? breakpoint : {})
          .some(state => isPlainObject(state) && LEGACY_FLAT_KEY in state)));
}

export function moveFlatBindingsToStates({ flat, cardIdsByState, requiredByCardId, bindingsByState }) {
  const out = cloneStates(bindingsByState);
  const moved = [];
  const attributed = new Set();
  boundStates(cardIdsByState).forEach(state => {
    const required = isPlainObject(requiredByCardId[Number(cardIdsByState[state])]) ? requiredByCardId[Number(cardIdsByState[state])] : {};
    Object.keys(required).forEach(name => {
      if (!isBoundContext(flat?.[name])) {
        return;
      }
      attributed.add(name);
      if (isBoundContext(out[state]?.[name])) {
        return;
      }
      out[state] = { ...out[state] ?? {}, [name]: flat[name] };
      moved.push({ state, name });
    });
  });
  const unattributed = Object.keys(isPlainObject(flat) ? flat : {}).filter(name => !attributed.has(name));
  return { bindingsByState: out, moved, unattributed };
}

export function planLegacyCompletionContextRepair({
  optionsTree, cardIdsByState, requiredByCardId, bindingsByState,
}) {
  const cardIds = boundStates(cardIdsByState).map(state => Number(cardIdsByState[state]));
  const ready = cardIds.every(id => requiredByCardId[id] !== null && requiredByCardId[id] !== undefined);
  const unchanged = { ready, changed: false, retireFlatKey: false, bindingsByState, moved: [], unattributed: [] };
  if (!ready) {
    return unchanged;
  }
  const moveResult = moveFlatBindingsToStates({
    flat: readLegacyFlatContextBindings(optionsTree),
    cardIdsByState,
    requiredByCardId,
    bindingsByState,
  });
  const retireFlatKey = hasLegacyFlatContextBindings(optionsTree);
  const changed = retireFlatKey || moveResult.moved.length > 0;
  return {
    ready,
    changed,
    retireFlatKey,
    bindingsByState: moveResult.bindingsByState,
    moved: moveResult.moved,
    unattributed: moveResult.unattributed,
  };
}
